/**
 * IvCert
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient, HttpHeaders, HttpParams,
  HttpResponse, HttpEvent
} from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';
import { Observable } from 'rxjs';
import { IvCertCircuitP } from '../model/ivCertCircuitP';
import { IvGenericRestResponseBoolean } from '../model/ivGenericRestResponseBoolean';
import { IvGenericRestResponseCircuit } from '../model/ivGenericRestResponseCircuit';
import { IvGenericRestResponseCircuitConfiguration } from '../model/ivGenericRestResponseCircuitConfiguration';
import { IvGenericRestResponseIvCertCircuitP } from '../model/ivGenericRestResponseIvCertCircuitP';
import { IvGenericRestResponseListCircuitStateP } from '../model/ivGenericRestResponseListCircuitStateP';
import { IvGenericRestResponseListCircuitTypeP } from '../model/ivGenericRestResponseListCircuitTypeP';
import { BASE_PATH } from '../variables';
import { Configuration } from '../configuration';
import { DateParser } from "../date";
import { IvCertGenericResponseBoolean } from '../model/ivCertGenericResponseBoolean';
import { IvCertGenericResponseListOrganizationUserL } from '../model/ivCertGenericResponseListOrganizationUserL';
import { IvCertGenericResponseListDocType } from '../model/ivCertGenericResponseListDocType';
import { PersonalizationsService } from '../../base/services/personalizations/personalizations.service';
import { Environment } from '../../models/environment';
import { IvCertGenericResponseListCircuitMembersCountPendingMsgsResponse } from '../model/ivCertGenericResponseListCircuitMembersCountPendingMsgsResponse';
import { ChatMessageRequest } from '../model/chatMessageRequest';
import { EnvironmentService } from './environment.service';
import { CreateCircuitDraftRequest } from '../model/createCircuitDraftRequest';
import { IvCertGenericResponseGetCircuitDraftResponse } from '../model/ivCertGenericResponseGetCircuitDraftResponse';
import { UpdateCircuitDraftRequest } from '../model/updateCircuitDraftRequest';
import { IvCertGenericResponseInt32 } from '../model/ivCertGenericResponseInt32';


@Injectable()
export class CircuitService {

  environment: Environment;
  protected basePath: string;
  protected apiVersion: string;
  public defaultHeaders = new HttpHeaders().set('timeClient', DateParser.parse(new Date()));
  public configuration = new Configuration();

  constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration, private _personalization: PersonalizationsService, private _env: EnvironmentService) {
    this.environment = this._personalization.sendEnv;
    this.apiVersion = this._env.apiVersion;
    this.basePath = this.environment?.url_api;
    this.defaultHeaders = this.defaultHeaders.set('X-Request-ID', 'app-front');
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * Cancelar el circuito
   *
   * @param idCircuit
   * @param authorization The authorization token
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public circuitDeleteCircuit(idCircuit: string, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvGenericRestResponseBoolean>;
  public circuitDeleteCircuit(idCircuit: string, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvGenericRestResponseBoolean>>;
  public circuitDeleteCircuit(idCircuit: string, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvGenericRestResponseBoolean>>;
  public circuitDeleteCircuit(idCircuit: string, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    if (idCircuit === null || idCircuit === undefined) {
      throw new Error('Required parameter idCircuit was null or undefined when calling circuitDeleteCircuit.');
    }

    if (authorization === null || authorization === undefined) {
      throw new Error('Required parameter authorization was null or undefined when calling circuitDeleteCircuit.');
    }

    let headers = this.defaultHeaders;
    if (authorization !== undefined && authorization !== null) {
      headers = headers.set('Authorization', String(authorization));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json',
      'text/json',
      'application/xml',
      'text/xml'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    return this.httpClient.delete<IvGenericRestResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/Circuit/${encodeURIComponent(String(idCircuit))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Post Method to delete a circuit draft.
   *
   * @param id Circuit Draft id to delete
   * @param Authorization The authorization token
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public circuitDeleteCircuitDraft(id: number, Authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
  public circuitDeleteCircuitDraft(id: number, Authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
  public circuitDeleteCircuitDraft(id: number, Authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
  public circuitDeleteCircuitDraft(id: number, Authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling circuitDeleteCircuitDraft.');
    }

    if (Authorization === null || Authorization === undefined) {
      throw new Error('Required parameter Authorization was null or undefined when calling circuitDeleteCircuitDraft.');
    }

    let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
    if (id !== undefined && id !== null) {
      queryParameters = queryParameters.set('id', <any>id);
    }

    let headers = this.defaultHeaders;
    if (Authorization !== undefined && Authorization !== null) {
      headers = headers.set('Authorization', String(Authorization));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json',
      'text/json',
      'application/xml',
      'text/xml'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
    ];

    return this.httpClient.delete<IvCertGenericResponseBoolean>(`${this.basePath}/api/v2/Circuit/Draft`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Devuelve la configuración según el tipo de circuito
   *
   * @param typeCircuit
   * @param authorization The authorization token
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public circuitGetActionsAvailableTypeCircuit(typeCircuit: string, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvGenericRestResponseCircuitConfiguration>;
  public circuitGetActionsAvailableTypeCircuit(typeCircuit: string, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvGenericRestResponseCircuitConfiguration>>;
  public circuitGetActionsAvailableTypeCircuit(typeCircuit: string, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvGenericRestResponseCircuitConfiguration>>;
  public circuitGetActionsAvailableTypeCircuit(typeCircuit: string, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
    if (typeCircuit === null || typeCircuit === undefined) {
      throw new Error('Required parameter typeCircuit was null or undefined when calling circuitGetActionsAvailableTypeCircuit.');
    }

    if (authorization === null || authorization === undefined) {
      throw new Error('Required parameter authorization was null or undefined when calling circuitGetActionsAvailableTypeCircuit.');
    }

    let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
    if (typeCircuit !== undefined) {
      queryParameters = queryParameters.set('typeCircuit', <any>typeCircuit);
    }

    let headers = this.defaultHeaders;
    if (authorization !== undefined && authorization !== null) {
      headers = headers.set('Authorization', String(authorization));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json',
      'text/json',
      'application/xml',
      'text/xml'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    return this.httpClient.get<IvGenericRestResponseCircuitConfiguration>(`${this.basePath}/api/${this.apiVersion}/Circuit/ActionsAvailableTypeCircuit`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    )
  }

  /**
   * Descarga el informe de auditoria sobre el circuito
   *
   * @param idCircuit Identificador del circuito
   * @param authorization The authorization token
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public circuitGetAuditCircuitPDF(idCircuit: string, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
  public circuitGetAuditCircuitPDF(idCircuit: string, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
  public circuitGetAuditCircuitPDF(idCircuit: string, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
  public circuitGetAuditCircuitPDF(idCircuit: string, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    if (idCircuit === null || idCircuit === undefined) {
      throw new Error('Required parameter idCircuit was null or undefined when calling circuitGetAuditCircuitPDF.');
    }

    if (authorization === null || authorization === undefined) {
      throw new Error('Required parameter authorization was null or undefined when calling circuitGetAuditCircuitPDF.');
    }

    let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
    if (idCircuit !== undefined && idCircuit !== null) {
      queryParameters = queryParameters.set('idCircuit', <any>idCircuit);
    }

    let headers = this.defaultHeaders;
    if (authorization !== undefined && authorization !== null) {
      headers = headers.set('Authorization', String(authorization));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json',
      'text/json',
      'application/xml',
      'text/xml'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    return this.httpClient.get(`${this.basePath}/api/${this.apiVersion}/Circuit/AuditCircuitPDF`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
        responseType: 'blob'
      }
    );
  }

  /**
   * Recupera la información de un circuito, ya sea por idCircuito o por externalId.
   *
   * @param authorization The authorization token
   * @param idCircuit Identificador interno del circuito
   * @param externalId Identificador externo del circuito
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public circuitGetCircuit(authorization: string, idCircuit?: string, externalId?: string, observe?: 'body', reportProgress?: boolean): Observable<IvGenericRestResponseCircuit>;
  public circuitGetCircuit(authorization: string, idCircuit?: string, externalId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvGenericRestResponseCircuit>>;
  public circuitGetCircuit(authorization: string, idCircuit?: string, externalId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvGenericRestResponseCircuit>>;
  public circuitGetCircuit(authorization: string, idCircuit?: string, externalId?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    if (authorization === null || authorization === undefined) {
      throw new Error('Required parameter authorization was null or undefined when calling circuitGetCircuit.');
    }



    let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
    if (idCircuit !== undefined && idCircuit !== null) {
      queryParameters = queryParameters.set('idCircuit', <any>idCircuit);
    }
    if (externalId !== undefined && externalId !== null) {
      queryParameters = queryParameters.set('externalId', <any>externalId);
    }

    let headers = this.defaultHeaders;
    if (authorization !== undefined && authorization !== null) {
      headers = headers.set('Authorization', String(authorization));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json',
      'text/json',
      'application/xml',
      'text/xml'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    return this.httpClient.get<any>(`${this.basePath}/api/${this.apiVersion}/Circuit`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Listado de estados disponibles para un circuito
   *
   * @param authorization The authorization token
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public circuitGetListStateCircuit(authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvGenericRestResponseListCircuitStateP>;
  public circuitGetListStateCircuit(authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvGenericRestResponseListCircuitStateP>>;
  public circuitGetListStateCircuit(authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvGenericRestResponseListCircuitStateP>>;
  public circuitGetListStateCircuit(authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
    if (authorization === null || authorization === undefined) {
      throw new Error('Required parameter authorization was null or undefined when calling circuitGetListStateCircuit.');
    }

    let headers = this.defaultHeaders;
    if (authorization !== undefined && authorization !== null) {
      headers = headers.set('Authorization', String(authorization));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json',
      'text/json',
      'application/xml',
      'text/xml'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    return this.httpClient.get<IvGenericRestResponseListCircuitStateP>(`${this.basePath}/api/${this.apiVersion}/Circuit/ListStateCircuit`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Listado de tipos de circuitos que se pueden generar
   *
   * @param authorization The authorization token
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public circuitGetListTypeCircuits(authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvGenericRestResponseListCircuitTypeP>;
  public circuitGetListTypeCircuits(authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvGenericRestResponseListCircuitTypeP>>;
  public circuitGetListTypeCircuits(authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvGenericRestResponseListCircuitTypeP>>;
  public circuitGetListTypeCircuits(authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
    if (authorization === null || authorization === undefined) {
      throw new Error('Required parameter authorization was null or undefined when calling circuitGetListTypeCircuits.');
    }

    let headers = this.defaultHeaders;
    if (authorization !== undefined && authorization !== null) {
      headers = headers.set('Authorization', String(authorization));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json',
      'text/json',
      'application/xml',
      'text/xml'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    return this.httpClient.get<IvGenericRestResponseListCircuitTypeP>(`${this.basePath}/api/${this.apiVersion}/Circuit/ListTypeCircuits`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get list organization employees
   *
   * @param authorization The authorization token
   * @param nameUser Filter by name user
   * @param apiVersion
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public circuitGetSearchUser(authorization: string, nameUser?: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseListOrganizationUserL>;
  public circuitGetSearchUser(authorization: string, nameUser?: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseListOrganizationUserL>>;
  public circuitGetSearchUser(authorization: string, nameUser?: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseListOrganizationUserL>>;
  public circuitGetSearchUser(authorization: string, nameUser?: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    if (authorization === null || authorization === undefined) {
      throw new Error('Required parameter authorization was null or undefined when calling circuitGetSearchUser.');
    }



    let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
    if (nameUser !== undefined && nameUser !== null) {
      queryParameters = queryParameters.set('nameUser', <any>nameUser);
    }
    if (apiVersion !== undefined && apiVersion !== null) {
      queryParameters = queryParameters.set('api-version', <any>apiVersion);
    }

    let headers = this.defaultHeaders;
    if (authorization !== undefined && authorization !== null) {
      headers = headers.set('Authorization', String(authorization));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json',
      'text/json',
      'application/xml',
      'text/xml'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    return this.httpClient.get<IvCertGenericResponseListOrganizationUserL>(`${this.basePath}/api/${this.apiVersion}/Circuit/SearchUser`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param authorization The authorization token
   * @param nameUser
   * @param apiVersion
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public circuitGetSearchUserIntern(authorization: string, nameUser?: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseListOrganizationUserL>;
  public circuitGetSearchUserIntern(authorization: string, nameUser?: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseListOrganizationUserL>>;
  public circuitGetSearchUserIntern(authorization: string, nameUser?: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseListOrganizationUserL>>;
  public circuitGetSearchUserIntern(authorization: string, nameUser?: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    if (authorization === null || authorization === undefined) {
      throw new Error('Required parameter authorization was null or undefined when calling circuitGetSearchUserIntern.');
    }



    let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
    if (nameUser !== undefined && nameUser !== null) {
      queryParameters = queryParameters.set('nameUser', <any>nameUser);
    }
    if (apiVersion !== undefined && apiVersion !== null) {
      queryParameters = queryParameters.set('api-version', <any>apiVersion);
    }

    let headers = this.defaultHeaders;
    if (authorization !== undefined && authorization !== null) {
      headers = headers.set('Authorization', String(authorization));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json',
      'text/json',
      'application/xml',
      'text/xml'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    return this.httpClient.get<IvCertGenericResponseListOrganizationUserL>(`${this.basePath}/api/${this.apiVersion}/Circuit/SearchUserIntern`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get Method to retrieve a circuit draft.
   *
   * @param id Id of the circuit draft to retrieve.
   * @param Authorization The authorization token
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public circuitGetCircuitDraft(id: number, Authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseGetCircuitDraftResponse>;
  public circuitGetCircuitDraft(id: number, Authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseGetCircuitDraftResponse>>;
  public circuitGetCircuitDraft(id: number, Authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseGetCircuitDraftResponse>>;
  public circuitGetCircuitDraft(id: number, Authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling circuitGetCircuitDraft.');
    }

    if (Authorization === null || Authorization === undefined) {
      throw new Error('Required parameter Authorization was null or undefined when calling circuitGetCircuitDraft.');
    }

    let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
    if (id !== undefined && id !== null) {
      queryParameters = queryParameters.set('id', <any>id);
    }

    let headers = this.defaultHeaders;
    if (Authorization !== undefined && Authorization !== null) {
      headers = headers.set('Authorization', String(Authorization));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json',
      'text/json',
      'application/xml',
      'text/xml'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
    ];

    return this.httpClient.get<IvCertGenericResponseGetCircuitDraftResponse>(`${this.basePath}/api/v2/Circuit/Draft`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Creación de circuito completo
   *
   * @param circuit
   * @param authorization The authorization token
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public circuitPostCircuit(circuit: IvCertCircuitP, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvGenericRestResponseIvCertCircuitP>;
  public circuitPostCircuit(circuit: IvCertCircuitP, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvGenericRestResponseIvCertCircuitP>>;
  public circuitPostCircuit(circuit: IvCertCircuitP, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvGenericRestResponseIvCertCircuitP>>;
  public circuitPostCircuit(circuit: IvCertCircuitP, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    if (circuit === null || circuit === undefined) {
      throw new Error('Required parameter circuit was null or undefined when calling circuitPostCircuit.');
    }

    if (authorization === null || authorization === undefined) {
      throw new Error('Required parameter authorization was null or undefined when calling circuitPostCircuit.');
    }

    let headers = this.defaultHeaders;
    if (authorization !== undefined && authorization !== null) {
      headers = headers.set('Authorization', String(authorization));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json',
      'text/json',
      'application/xml',
      'text/xml'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'text/json',
      'application/xml',
      'text/xml',
      'application/x-www-form-urlencoded'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.post<IvGenericRestResponseIvCertCircuitP>(`${this.basePath}/api/${this.apiVersion}/Circuit`,
      circuit,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
    *
    *
    * @param idCircuit
    * @param idOperation
    * @param authorization The authorization token
    * @param apiVersion
    * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
    * @param reportProgress flag to report request and response progress.
    */
  public circuitPutActiveCircuitOperation(idCircuit: string, idOperation: string, authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
  public circuitPutActiveCircuitOperation(idCircuit: string, idOperation: string, authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
  public circuitPutActiveCircuitOperation(idCircuit: string, idOperation: string, authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
  public circuitPutActiveCircuitOperation(idCircuit: string, idOperation: string, authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    if (idCircuit === null || idCircuit === undefined) {
      throw new Error('Required parameter idCircuit was null or undefined when calling circuitPutActiveCircuitOperation.');
    }

    if (idOperation === null || idOperation === undefined) {
      throw new Error('Required parameter idOperation was null or undefined when calling circuitPutActiveCircuitOperation.');
    }

    if (authorization === null || authorization === undefined) {
      throw new Error('Required parameter authorization was null or undefined when calling circuitPutActiveCircuitOperation.');
    }


    let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
    if (idCircuit !== undefined && idCircuit !== null) {
      queryParameters = queryParameters.set('idCircuit', <any>idCircuit);
    }
    if (idOperation !== undefined && idOperation !== null) {
      queryParameters = queryParameters.set('idOperation', <any>idOperation);
    }
    if (apiVersion !== undefined && apiVersion !== null) {
      queryParameters = queryParameters.set('api-version', <any>apiVersion);
    }

    let headers = this.defaultHeaders;
    if (authorization !== undefined && authorization !== null) {
      headers = headers.set('Authorization', String(authorization));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json',
      'text/json',
      'application/xml',
      'text/xml'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    return this.httpClient.put<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/Circuit/ActiveCircuit`,
      null,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param authorization The authorization token
   * @param apiVersion
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public circuitGetDocType(authorization: string, apiVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseListDocType>;
  public circuitGetDocType(authorization: string, apiVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseListDocType>>;
  public circuitGetDocType(authorization: string, apiVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseListDocType>>;
  public circuitGetDocType(authorization: string, apiVersion?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    if (authorization === null || authorization === undefined) {
      throw new Error('Required parameter authorization was null or undefined when calling circuitGetDocType.');
    }


    let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
    if (apiVersion !== undefined && apiVersion !== null) {
      queryParameters = queryParameters.set('api-version', <any>apiVersion);
    }

    let headers = this.defaultHeaders;
    if (authorization !== undefined && authorization !== null) {
      headers = headers.set('Authorization', String(authorization));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json',
      'text/json',
      'application/xml',
      'text/xml'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    return this.httpClient.get<IvCertGenericResponseListDocType>(`${this.basePath}/api/${this.apiVersion}/Circuit/DocType`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Save circuit draft
   *
   * @param request
   * @param Authorization The authorization token
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public circuitPostDraft(request: CreateCircuitDraftRequest, Authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseInt32>;
  public circuitPostDraft(request: CreateCircuitDraftRequest, Authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseInt32>>;
  public circuitPostDraft(request: CreateCircuitDraftRequest, Authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseInt32>>;
  public circuitPostDraft(request: CreateCircuitDraftRequest, Authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    if (request === null || request === undefined) {
      throw new Error('Required parameter request was null or undefined when calling circuitPostDraft.');
    }

    if (Authorization === null || Authorization === undefined) {
      throw new Error('Required parameter Authorization was null or undefined when calling circuitPostDraft.');
    }

    let headers = this.defaultHeaders;
    if (Authorization !== undefined && Authorization !== null) {
      headers = headers.set('Authorization', String(Authorization));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json',
      'text/json',
      'application/xml',
      'text/xml'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'text/json',
      'application/xml',
      'text/xml',
      'application/x-www-form-urlencoded'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.post<IvCertGenericResponseInt32>(`${this.basePath}/api/v2/Circuit/Draft`,
      request,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Update a circuit draft.
   *
   * @param request Request to update a circuit draft.
   * @param Authorization The authorization token
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public circuitPutCircuitDraft(request: UpdateCircuitDraftRequest, Authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
  public circuitPutCircuitDraft(request: UpdateCircuitDraftRequest, Authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
  public circuitPutCircuitDraft(request: UpdateCircuitDraftRequest, Authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
  public circuitPutCircuitDraft(request: UpdateCircuitDraftRequest, Authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    if (request === null || request === undefined) {
      throw new Error('Required parameter request was null or undefined when calling circuitPutCircuitDraft.');
    }

    if (Authorization === null || Authorization === undefined) {
      throw new Error('Required parameter Authorization was null or undefined when calling circuitPutCircuitDraft.');
    }

    let headers = this.defaultHeaders;
    if (Authorization !== undefined && Authorization !== null) {
      headers = headers.set('Authorization', String(Authorization));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json',
      'text/json',
      'application/xml',
      'text/xml'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'text/json',
      'application/xml',
      'text/xml',
      'application/x-www-form-urlencoded'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.put<IvCertGenericResponseBoolean>(`${this.basePath}/api/v2/Circuit/Draft`,
      request,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Insert a new chat message.
   *
   * @param message
   * @param authorization The authorization token
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public circuitPostSendChatMessage(message: ChatMessageRequest, authorization: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
  public circuitPostSendChatMessage(message: ChatMessageRequest, authorization: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
  public circuitPostSendChatMessage(message: ChatMessageRequest, authorization: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
  public circuitPostSendChatMessage(message: ChatMessageRequest, authorization: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    if (message === null || message === undefined) {
      throw new Error('Required parameter message was null or undefined when calling circuitPostSendChatMessage.');
    }

    if (authorization === null || authorization === undefined) {
      throw new Error('Required parameter authorization was null or undefined when calling circuitPostSendChatMessage.');
    }

    let headers = this.defaultHeaders;
    if (authorization !== undefined && authorization !== null) {
      headers = headers.set('Authorization', String(authorization));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json',
      'text/json',
      'application/xml',
      'text/xml'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'text/json',
      'application/x-www-form-urlencoded'
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.post<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/Circuit/SendChatMessage`,
      message,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
     * Gets all pending messages, when receiver is null we return all chats and pending messages for the transaction creator,  when receiver is supplied we return chat and pending messages sent by transaction creator to the receiver.
     *
     * @param circuitId Transaction guid.
     * @param authorization The authorization token
     * @param receiver Optional parameter, should have content when is called by extern users and can be an email or a signerGuid.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
  public circuitGetReceiversCountPendingMessages(circuitId: string, authorization: string, receiver?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseListCircuitMembersCountPendingMsgsResponse>;
  public circuitGetReceiversCountPendingMessages(circuitId: string, authorization: string, receiver?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseListCircuitMembersCountPendingMsgsResponse>>;
  public circuitGetReceiversCountPendingMessages(circuitId: string, authorization: string, receiver?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseListCircuitMembersCountPendingMsgsResponse>>;
  public circuitGetReceiversCountPendingMessages(circuitId: string, authorization: string, receiver?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    if (circuitId === null || circuitId === undefined) {
      throw new Error('Required parameter circuitId was null or undefined when calling circuitGetReceiversCountPendingMessages.');
    }

    if (authorization === null || authorization === undefined) {
      throw new Error('Required parameter authorization was null or undefined when calling circuitGetReceiversCountPendingMessages.');
    }


    let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
    if (circuitId !== undefined && circuitId !== null) {
      queryParameters = queryParameters.set('circuitId', <any>circuitId);
    }
    if (receiver !== undefined && receiver !== null) {
      queryParameters = queryParameters.set('receiver', <any>receiver);
    }

    let headers = this.defaultHeaders;
    if (authorization !== undefined && authorization !== null) {
      headers = headers.set('Authorization', String(authorization));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json',
      'text/json',
      'application/xml',
      'text/xml'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
    ];

    return this.httpClient.get<IvCertGenericResponseListCircuitMembersCountPendingMsgsResponse>(`${this.basePath}/api/${this.apiVersion}/Circuit/GetReceiversCountPendingMessages`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Gets user&#39;s messages for an especific transaction.
   *
   * @param circuitGuid Circuit&#39;s identificator
   * @param idUser User&#39;s identificator
   * @param authorization The authorization token
   * @param top The max number of records. (e.g. $top&#x3D;10)
   * @param skip The number of records to skip. (e.g. $skip&#x3D;5)
   * @param filter A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq &#39;bob&#39;)
   * @param select Specifies a subset of properties to return. (e.g. $select&#x3D;Name)
   * @param inlinecount Tells the server to include the total count of matching entities in the response. (e.g. $inlinecount&#x3D;allpages)
   * @param orderby Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public circuitGetODataCircuitUserMessages(circuitGuid: string, idUser: string, authorization: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe?: 'body', reportProgress?: boolean): Observable<IvCertGenericResponseBoolean>;
  public circuitGetODataCircuitUserMessages(circuitGuid: string, idUser: string, authorization: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IvCertGenericResponseBoolean>>;
  public circuitGetODataCircuitUserMessages(circuitGuid: string, idUser: string, authorization: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IvCertGenericResponseBoolean>>;
  public circuitGetODataCircuitUserMessages(circuitGuid: string, idUser: string, authorization: string, top?: string, skip?: string, filter?: string, select?: string, inlinecount?: string, orderby?: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    if (circuitGuid === null || circuitGuid === undefined) {
      throw new Error('Required parameter circuitGuid was null or undefined when calling circuitGetODataCircuitUserMessages.');
    }

    if (idUser === null || idUser === undefined) {
      throw new Error('Required parameter idUser was null or undefined when calling circuitGetODataCircuitUserMessages.');
    }

    if (authorization === null || authorization === undefined) {
      throw new Error('Required parameter authorization was null or undefined when calling circuitGetODataCircuitUserMessages.');
    }

    let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
    if (circuitGuid !== undefined && circuitGuid !== null) {
      queryParameters = queryParameters.set('circuitGuid', <any>circuitGuid);
    }
    if (idUser !== undefined && idUser !== null) {
      queryParameters = queryParameters.set('idUser', <any>idUser);
    }
    if (top !== undefined && top !== null) {
      queryParameters = queryParameters.set('$top', <any>top);
    }
    if (skip !== undefined && skip !== null) {
      queryParameters = queryParameters.set('$skip', <any>skip);
    }
    if (filter !== undefined && filter !== null) {
      queryParameters = queryParameters.set('$filter', <any>filter);
    }
    if (select !== undefined && select !== null) {
      queryParameters = queryParameters.set('$select', <any>select);
    }
    if (inlinecount !== undefined && inlinecount !== null) {
      queryParameters = queryParameters.set('$inlinecount', <any>inlinecount);
    }
    if (orderby !== undefined && orderby !== null) {
      queryParameters = queryParameters.set('$orderby', <any>orderby);
    }

    let headers = this.defaultHeaders;
    if (authorization !== undefined && authorization !== null) {
      headers = headers.set('Authorization', String(authorization));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json',
      'text/json',
      'application/xml',
      'text/xml'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
    ];

    return this.httpClient.get<IvCertGenericResponseBoolean>(`${this.basePath}/api/${this.apiVersion}/Circuit/CircuitUserMessages`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

}
